export enum TaskTypeString {
    Grant = 'Grant',
    Revoke = 'Revoke',
    Certify = 'Certify',
    Action = 'Action',
    Invalid = 'Invalid',
}
